import React, { useState } from "react"
import { Link, useHistory, useParams } from "react-router-dom"
import DeleteModal from "../../../components/Common/DeleteModal"
import { usePagination } from "../../../hooks/usePagination"
import ResultHandler from "../../../components/ResultHandler"
import PaginationHandler from "../../../components/PaginationHandler"
import { deletePayslipe, getPayslipes, getEmployeePayslipes, payPayslipe } from "../../../api/payslipes"
import TableHeaderHandler from "../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../hooks/useResponse"
import TableAction from "../../../components/TableAction"
import EmptyData from "../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import moment from "moment"
import { Badge, Button, Col, Label, Row } from "reactstrap"
import ExportBtn from "./ExportBtn"
import { formatCurrency } from "../../../utils/formatCurrency"
import BlockPaymentBtn from "../employees/BlockPaymentBtn"
import TableFilter from "../../../components/TableFilter"

const STATUSE = {
  pending: {color: "warning", text: "Pending"},
  paid: {color: "success", text: "Paid"},
  rejected: {color: "danger", text: "Rejected"},

}

export default function PayslipesTable({hasBlockPaymentBtn, blockPayments}) {

  const { t } = useTranslation()
  const navigate = useHistory()
  const {id:employeeId} = useParams()
  
  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta
  } = usePagination(employeeId ? getEmployeePayslipes : getPayslipes, {employeeId})

  function handleRefresh(){
    setPayload({employeeId, ref: true})
  }

  //// delete 
  const [show, setShow] = useState(false)
  const [deletingPayslipe, setDeletingPayslipe] = useState(null)

  const { setData } = useResponse(deletePayslipe, () => {
    setShow(false)
    setDeletingPayslipe(null)
    handleRefresh()
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingPayslipe })
  }


  function onCloseClick() {
    setShow(false)
  }
  
  //////// pay

  const [selectedToPay, setSelectedToPay] = useState([])

  const { loading: payLoading, error: payErr, setData: setPay } = useResponse(payPayslipe, () => {
    handleRefresh()
    setSelectedToPay([])
  })


  function handlePay(){
    setPay({type: "add", data: {ids: selectedToPay}})
  }

  // Filters
  const filterTypes = [
    {key: "employee", type: "text", hide: employeeId ? true : false},
    {key: "date", type: "date"},
    {key: "status", type: "select", options: [
      {label: "All", value: "all"},
      {label: "Paid", value: "paid"},
      {label: "Pending", value: "pending"},
    ]},
    {key: "price", type: "number"},
  ]

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.PAYSLIPE_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="/add-payslipe"
      >
        <div className="me-3 d-flex gap-3">
          {hasBlockPaymentBtn && <BlockPaymentBtn employeeId={employeeId} blockPayments={blockPayments} />}
          <ExportBtn employeeId={employeeId}/>
        </div>
      </TableHeaderHandler>

      <TableFilter
        filterTypes={filterTypes}
        onFilter={(filters) => setMeta({ page: 1, payload: {employeeId, filters}})}
      />


      {selectedToPay.length > 0 && <div className="mb-4 d-flex" style={{}}>

        <Badge color="dark" className="d-flex" style={{fontSize: "16px", alignItems: "center"}}>
          {selectedToPay.length} selected 
          <span style={{opacity: "0.5", margin: "0px 6px"}}>|</span> 
          <i style={{cursor: "pointer"}} className="mdi mdi-close" onClick={() => setSelectedToPay([])}></i>
        </Badge>

        {!payLoading && <Button color="dark" style={{marginLeft: "10px"}} onClick={handlePay}>
          Bulk Pay
        </Button>}
        {payLoading && <Button style={{marginLeft: "10px"}}>
          Wait
        </Button>}
      </div>}

      <ResultHandler error={payErr} />

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th style={{width: "3%"}}></Th>
                <Th>Date</Th>
                <Th>Employee</Th>
                <Th>Price</Th>
                <Th>Status</Th>

                <Th style={{ width: "15%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.payslipes.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td className="text-center">
                        <input 
                          checked={selectedToPay.includes(row.id)} 
                          type="checkbox" 
                          style={{cursor: 'pointer'}}
                          onChange={() => {
                            if(selectedToPay.includes(row.id)){
                              setSelectedToPay(s => s.filter(p => p != row.id))
                            }else{
                              setSelectedToPay(s => ([...s, row.id]))
                            }
                          }}
                        />
                      </Td>
                      <Td>
                        {moment(row.date).format("DD MMM YYYY")}
                      </Td>
                      <Td>
                        {row.employee.name}
                      </Td>
                      <Td>{formatCurrency(row.price)}</Td>
                      <Td>
                        <Badge style={{fontSize: "14px"}} color={STATUSE[row.status].color}>
                          {STATUSE[row.status].text}
                        </Badge>
                        {(new Date() > new Date(row.date)) && row.status != "paid" && <div className="d-block invalid-feedback">Alert: payslip date has passed</div>}
                      </Td> 
                      <Td>
                        <TableAction
                          hasDelete={true}
                          deletePermission={PERMISSIONS.PAYSLIPE_DELETE}
                          type="payslipe"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingPayslipe}
                        />
                         <Button onClick={() => navigate.push('/payslipe-details/'+row.id, {payslipe: row})} style={{marginLeft: "5px"}} color="dark">
                          <i className="bx bxs-show font-size-16 align-middle" />
                        </Button>
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.payslipes.length === 0} msg="No Payslipes Found." />
          }
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />


          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}


     
          <ResultHandler error={error} loading={loading} />

        </div>
      </div>
    </>
  )
}
